import { CommandParser } from '@redis/client/dist/lib/client/parser';
import { RedisArgument, NumberReply, Command } from '@redis/client/dist/lib/RESP/types';

export interface JsonDelOptions {
  path?: RedisArgument
}

export default {
  parseCommand(parser: CommandParser, key: RedisArgument, options?: JsonDelOptions) {
    parser.push('JSON.DEL');
    parser.pushKey(key);

    if (options?.path !== undefined) {
      parser.push(options.path);
    }
  },
  transformReply: undefined as unknown as () => NumberReply
} as const satisfies Command;
